// Language/Domain configuration
export const LANGUAGE_CONFIG = {
  'cs-CZ': {
    name: 'Čeština', 
    flag: 'cz',
    domain: 'nukeproof-bikes.cz'
  },


  /*

  -- Smazal jsem to protože ty domény nejsou takže ať to tam radši není než aby to odkazovalo na nefunkční web

  'sk-SK': {
    name: 'Slovenčina',
    flag: 'sk', 
    domain: 'nukeproof-bikes.sk'
  },
  'pl-PL': {
    name: 'Polski',
    flag: 'pl',
    domain: 'nukeproof-bike.pl'
  },
  'hu-HU': {
    name: 'Magyar',
    flag: 'hu',
    domain: 'nukeproof-bikes.hu'
  }
  */


};

// Get current language from domain
export const getCurrentLanguage = () => {
  try {
    const hostname = window.location.hostname;
    
    // Check for localhost
    if (hostname === 'localhost' || hostname === '127.0.0.1') {
      return 'cs-CZ';
    }
    
    // Find matching language
    for (const [locale, config] of Object.entries(LANGUAGE_CONFIG)) {
      if (hostname.includes(config.domain)) {
        return locale;
      }
    }
    
    return 'cs-CZ'; // Default to Czech
  } catch (error) {
    return 'cs-CZ';
  }
};

// Switch to different language domain
export const switchLanguage = (targetLocale) => {
  const config = LANGUAGE_CONFIG[targetLocale];
  if (!config) return;
  
  const currentPath = window.location.pathname + window.location.search + window.location.hash;
  const currentHostname = window.location.hostname;
  
  // If we're on localhost, just reload (can't change domain)
  if (currentHostname === 'localhost' || currentHostname === '127.0.0.1') {
    console.log(`Would redirect to: https://${config.domain}${currentPath}`);
    return;
  }
  
  // Construct new URL with the target domain
  const newUrl = `${window.location.protocol}//${config.domain}${currentPath}`;
  
  // Redirect to the new domain
  window.location.href = newUrl;
};
